export const truncateStringWithEllipses = (limitedLength, value = "") =>
  value.length > limitedLength ? value.slice(0, limitedLength) + "..." : value;

export const additionbaselor = (base, lor) => {
  let num = (parseFloat(base) + parseFloat(lor)).toFixed(2);
  return isNaN(num) === true ? 0 : num;
};

export const getMenuAccess = () => {
  try {
    const menuAccessStr = localStorage.getItem("menuAccess");
    if (!menuAccessStr) return {};
    return JSON.parse(menuAccessStr);
  } catch {
    return {};
  }
};

export const getMenuPermissions = (menuKey) => {
  const menuAccess = getMenuAccess();
  return menuAccess?.[menuKey] || {};
};

export const hasMenuPermission = (menuKey, permissions) => {
  const menuPermissions = getMenuPermissions(menuKey);

  if (Array.isArray(permissions)) {
    return permissions.some(
      (permission) => menuPermissions[permission] === true,
    );
  }

  return menuPermissions[permissions] === true;
};

export const hasAllMenuPermissions = (menuKey, permissions) => {
  const menuPermissions = getMenuPermissions(menuKey);

  if (Array.isArray(permissions)) {
    return permissions.every(
      (permission) => menuPermissions[permission] === true,
    );
  }

  return menuPermissions[permissions] === true;
};
